import { type FieldEntryGrouping } from './types.ts';

export const KEY_DELIMITER = ',';

/**
 * Generates a unique key for a field entry grouping.
 * @param grouping
 */
export const getKey = (grouping: FieldEntryGrouping): string => {
  const fieldId = 'fieldId' in grouping ? grouping.fieldId : null;
  const entryId = 'entryId' in grouping ? grouping.entryId : null;
  return `${fieldId}${KEY_DELIMITER}${entryId}`;
};

/**
 * Inverse operation of getKey. Given the key, it returns a FieldEntryGrouping object.
 * @param key
 */
export const getGrouping = (key: string): FieldEntryGrouping => {
  const ids = key.split(KEY_DELIMITER);

  return {
    fieldId: ids[0],
    entryId: ids[1]
  };
};

export function areArraysShallowEqual<T>(a: T[], b: T[]): boolean {
  if (a === b) {
    return true;
  }
  if (a.length !== b.length) {
    return false;
  }
  for (let i = 0; i < a.length; i++) {
    if (a[i] !== b[i]) {
      return false;
    }
  }
  return true;
}

export function isCellGrouping(
  grouping: FieldEntryGrouping
): grouping is { fieldId: string; entryId: string } {
  return (
    'fieldId' in grouping &&
    'entryId' in grouping &&
    grouping.fieldId !== 'null' &&
    grouping.entryId !== 'null'
  );
}

export function isRowGrouping(
  grouping: FieldEntryGrouping
): grouping is { entryId: string } {
  return (
    !isCellGrouping(grouping) && 'entryId' in grouping && grouping.entryId !== 'null'
  );
}

export function isColumnGrouping(
  grouping: FieldEntryGrouping
): grouping is { fieldId: string } {
  return (
    !isCellGrouping(grouping) && 'fieldId' in grouping && grouping.fieldId !== 'null'
  );
}
